import { Component } from '@angular/core';
import { HomePage } from '../home/home';
import { AccountPage } from '../account/account';
import { LotteryOpenPage } from '../lotteryopen/lotteryopen';
import { PromotionPage } from '../promotion/promotion';
import { StorageService } from '../../providers/storage.service';
import { SysconfigModel } from '../../models/user.model';
import { Events } from 'ionic-angular';
import { BrowserPage } from '../browser/browser';
import { AppConfig } from '../../app/app.config';

@Component({
    selector: "tabs",
    templateUrl: 'tabs.html'
})
export class TabsPage {

    tab1Root: any = HomePage;
    tab2Root: any = LotteryOpenPage;
    tab3Root: any = BrowserPage;
    tab4Root: any = PromotionPage;
    tab5Root: any = AccountPage;

    tabBadge: string;
    constructor(private storage: StorageService, private config: AppConfig,
        private events: Events) {
        this.tabBadge = '';
    }

    //在线客服
    //TQQ 2017-01-19
    customer() {
        let connect = this.storage.read<SysconfigModel>("sysconfig");
        this.config.openUrl(connect.CustomerServiceUrl);
    }

    /**
     *   
     */
    ionViewDidLoad() {
        this.events.subscribe('unreadMessage', (params) => {
            if (params > 0) {
                this.tabBadge = ' ';
            } else { this.tabBadge = ''; }
            // this.events.unsubscribe('unreadMessage');
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts